import React, { Component } from "react";
import {
  Box,
  Typography,
  Avatar,
  IconButton,
  TextField
} from "@material-ui/core";
import {
  Edit,
  PersonAddOutlined,
  Cancel,
  AddCircle,
  Group,
  Person
} from "@material-ui/icons";
import { withStyles } from "@material-ui/core/styles";
import myStyles from "./Style";
import { FirebaseContext } from "../../FirebaseInit";

class ChatHeader extends Component {
  constructor(props) {
    super(props);
    this.state = {
      newMember: false,
      member: ""
    };

    this.handleClick = this.handleClick.bind(this);
    this.handleChange = this.handleChange.bind(this);
  }

  handleChange(e) {
    this.setState({ member: e.target.value });
  }

  handleClick(firebase, e) {
    if (e.currentTarget.name === "add") {
      firebase
        .fs()
        .collection("users")
        .where("email", "==", this.state.member)
        .get()
        .then(doc => {
          if (doc.empty) {
            this.props.toggleAlert(
              `User (${this.state.member}) does not exist`,
              "error"
            );
            return;
          }
          firebase
            .fs()
            .collection("groups")
            .doc(this.props.chatData.id)
            .set(
              {
                members: firebase.fs.FieldValue.arrayUnion(this.state.member),
                membersInfo: {
                  [doc.docs[0].id]: {
                    admin: false,
                    email: doc.docs[0].data().email,
                    username: doc.docs[0].data().username,
                    ppURL: doc.docs[0].data().ppURL,
                    joined: firebase.fs.Timestamp.now()
                  }
                },
                unread: {
                  [doc.docs[0].id]: {
                    count: 0,
                    status: "Out"
                  }
                },
                lastmod:firebase.fs.Timestamp.now()
              },
              { merge: true }
            )
            .then(() => {
              firebase
                .fs()
                .collection("groups")
                .doc(this.props.chatData.id)
                .collection("messages")
                .add({
                  message: `${doc.docs[0].data().username}(${
                    this.state.member
                  }) joined`,
                  type: "info",
                  timestamp:firebase.fs.Timestamp.now()
                });
            })
            .catch(err =>
             { console.log(err)
              this.props.toggleAlert(
                "Uh oh! An error occured, please try again.",
                "error"
              )}
            );
        });
    }
    this.setState({ newMember: !this.state.newMember });
  }

  render() {
    const { classes, chaType, chatData } = this.props;
    const firebase = this.context;
    return (
      <>
        <Box
          flexWrap="wrap"
          px={1}
          boxShadow={1}
          display="flex"
          alignItems="center"
        >
          <Avatar className={classes.avatar} src={chatData.ppURL}>
            {chaType === "private" && <Person />}
            {chaType === "group" && <Group />}
          </Avatar>
          <Box flexWrap="wrap" display="flex" alignItems="center" p={1} ml={1}>
            <Typography variant="subtitle1">
              {chaType === "private" ? chatData.username : chatData.name}
            </Typography>
            {/* <Typography
              style={{ marginLeft: "5px" }}
              variant="subtitle2"
              color="textSecondary"
            >
              {chaType === "private" ? `(${chatData.email})` : null}
            </Typography> */}
            {chaType === "group" && (
              <IconButton
                onClick={this.props.toggleDialog.bind(
                  this,
                  "Group",
                  "Group Settings",chatData
                )}
                style={{ marginLeft: "10px" }}
              >
                <Edit />
              </IconButton>
            )}
            {chaType === "private" && (
              <IconButton
                onClick={this.props.toggleDialog.bind(
                  this,
                  "Private",
                  "Chat Info",chatData
                )}
                style={{ marginLeft: "10px" }}
              >
                <Edit />
              </IconButton>
            )}
          </Box>
          {chaType === "group" && (
            <Box ml="auto">
              <IconButton
                onClick={this.handleClick.bind(this, null)}
                color="secondary"
              >
                <PersonAddOutlined fontSize="large" />
              </IconButton>
            </Box>
          )}
        </Box>
        {this.state.newMember && (
          <Box display="flex" mt={1}>
            <TextField
              onChange={this.handleChange}
              fullWidth
              autoFocus
              variant="filled"
              label={"Enter an email"}
              required
            />
            <Box ml={1}>
              <IconButton
                onClick={this.handleClick.bind(this, firebase)}
                color="primary"
                name="add"
                size="small"
              >
                <AddCircle />
              </IconButton>
              <IconButton
                name="cancel"
                color="secondary"
                onClick={this.handleClick.bind(this, null)}
                size="small"
              >
                <Cancel />
              </IconButton>
            </Box>
          </Box>
        )}
      </>
    );
  }
}
ChatHeader.contextType = FirebaseContext;
export default withStyles(myStyles)(ChatHeader);
